import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import { ACTION_TYPES } from "../../../app/actionTypes";
import {
  setActionPayload,
  setActionType,
} from "../../../features/authorizationSlice";
import { resetRequest } from "../../../features/transactionDetailsSlice";

export default function ApproveRejectPayroll({
  payrollId,
  onOpenQrAfterGenerate,
}) {
  const dispatch = useDispatch();

  const handleApproveReject = useCallback(
    (status) => {
      dispatch(resetRequest());
      dispatch(
        setActionType(
          status === "Approve"
            ? ACTION_TYPES.APPROVE_PAYROLL
            : ACTION_TYPES.REJECT_PAYROLL,
        ),
      );
      dispatch(
        setActionPayload({
          Reference: payrollId,
          PayrollIds: [],
        }),
      );
      onOpenQrAfterGenerate?.();
    },
    [payrollId],
  );

  return (
    <div className="new-approval-action-group new-pending-approvals-page__yes-no">
      <button
        type="button"
        className="new-approval-action-button is-approve new-pending-approvals-page__yes-action"
        onClick={(event) => {
          event.stopPropagation();
          handleApproveReject("Approve");
        }}
        aria-label={`Approve payroll ${payrollId}`}
      >
        <FontAwesomeIcon icon={faCheck} />
      </button>
      <button
        type="button"
        className="new-approval-action-button is-reject new-pending-approvals-page__no-action"
        onClick={(event) => {
          event.stopPropagation();
          handleApproveReject("Reject");
        }}
        aria-label={`Reject payroll ${payrollId}`}
      >
        <FontAwesomeIcon icon={faXmark} />
      </button>
    </div>
  );
}
